import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import ManageTraitement from '@/views/consultations/en-cours/protocole-soins/traitement-en-cours/manage-traitement'
import Plaintes from '@/views/consultations/en-cours/protocole-soins/traitement-en-cours/plaintes'
import Evenements from '@/views/consultations/en-cours/protocole-soins/traitement-en-cours/evenement'
import ManageProtocoleData from '@/views/consultations/en-cours/protocole-soins/traitement-en-cours/manage-protocole-data'

export default {
    name: 'traitement-en-cours',
    components: {
        ManageTraitement, Plaintes, Evenements, ManageProtocoleData
    },
    props: {
        consultation_id: Number,
        user_id: Number,
        traitement_view_toggler: Number
    },
    data() {
        return {
            vm_state: open_menu_state,
            is_loading: true,
            soin_is_loading: false,
            is_empty: true,
            action_info: {
                modal_title: ''
            },
            soin_justif: '',
            data_to_add: {},
            single_action_info: {}
        }
    },

    watch: {
        traitement_view_toggler() {
            this.getListeTraitementEnCours()
        }
    },

    computed: {
        traitement_en_cours() {
            return this.$store.getters['traitement_en_cours'];
        },
    },

    mounted() {
        const ts = this;
        $(document).bind("click", function(e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        getListeTraitementEnCours() {
            this.soin_is_loading = true

            const data = {
                consultation_id: this.consultation_id,
            }
            this.$store.dispatch('getTraitementEnCours', data).then(() => {
                if (this.traitement_en_cours.length == 0) {
                    this.is_empty = true 
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
                this.soin_is_loading = false
            })
        },

        dropContent(selector) {
            console.log(selector);
            var el = document.getElementById(selector)

            // Check if element has class show
            if ($('#'+selector).hasClass("show")) {
                el.classList.remove('show')
            } else {
                el.classList.add('show')
            }
        },

        /**
         * 0 => Démarrer | 1 => Arrêter | 2 => Terminer
         * @param {*} state 
         */
        doAction(state, medicaments, protocole) {
            const title = (state == 0)?'Démarrer soin':(state == 1)?'Arrêter soin':(state == 2)?'Terminer soin':'Soin non fait'

            /**
             * @process_status 1 => Démarré | 2 => Terminé | 3 => Arrêté | 4 => Non fait
             */
            const process_status = (state == 0)?1:(state == 1)?3:(state == 2)?2:4

            this.action_info = {
                evolution_id: protocole.evolution_id,
                consultation_id: this.consultation_id,
                protocole_id: protocole.protocole_id,
                modal_title: title,
                process_status: process_status,
                medicaments: medicaments
            }
        },

        viewJustif(justif) {
            this.soin_justif = justif
        },

        addProtocoleData(data, data_id, protocole_id, hn) {
            this.data_to_add = {
                data_id: data_id,
                data_type: data,
                libelle: (data == 'plainte')?'Plainte patient':'Evènement',
                protocole_id: protocole_id,
                hn: hn
            }
        },

        doSingleAction(state, medicament, protocole) {
            const title = (state == 0)?'Démarrer un soin':(state == 1)?'Arrêter un soin':(state == 2)?'Terminer un soin':'Soin non fait'

            /**
             * @process_status 1 => Démarré | 2 => Terminé | 3 => Arrêté | 4 => Non fait
             */
            const process_status = (state == 0)?1:(state == 1)?3:(state == 2)?2:4

            this.single_action_info = {
                evolution_id: protocole.evolution_id,
                consultation_id: this.consultation_id,
                protocole_id: protocole.protocole_id,
                modal_title: title,
                process_status: process_status,
                medicament: medicament
            }
        }
    }
}


